import { render, staticRenderFns } from "./BirthdayStep.vue?vue&type=template&id=483f5ae6&"
import script from "./BirthdayStep.vue?vue&type=script&lang=js&"
export * from "./BirthdayStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports